import { render, staticRenderFns } from "./user_wtfw.vue?vue&type=template&id=ae8b2bee&scoped=true"
import script from "./user_wtfw.vue?vue&type=script&lang=js"
export * from "./user_wtfw.vue?vue&type=script&lang=js"
import style0 from "./user_wtfw.vue?vue&type=style&index=0&id=ae8b2bee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8b2bee",
  null
  
)

export default component.exports